import * as XLSX from 'xlsx'; 
export function hexToRgba(hex, transparency) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');

    // Parse the r, g, b values from the hex code
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Convert transparency percentage to a decimal (0-1)
    let alpha = transparency / 100;

    // Return the rgba string
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
export const exportToExcel = ({ data, filename = 'export.xlsx', }) => {
    let Data = data;

    if (!Data.length) {
        alert("No matching data found to export.");
        console.warn("No matching data found to export.");
        return;
    }

    const dataToExport =data

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, filename);
};

export function mergeReportData(columns, result) {
  const fieldnames = columns;
  return result.map(row => {
    const rowObj = {};
    fieldnames.forEach((key, index) => {
      rowObj[key] = row[index];
    });
    return rowObj;
  });
}